import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { useCameraAutoAddStore } from "../CameraAutoAddStore/cameraAutoAddStore";
import { createCamerasObject } from "./createCamerasObject";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { NavigateFunction } from "react-router-dom";
import { productsMatcher } from "../../../utils/productsMatcher";
import { getBlockedProductIdsForSelectedIds } from "../../../common/onBoardingWizardFieldTypes/cameraProductsMutualExclusion";

export const handleLoadMoreAutoAddData = (
  setCamerasList: any,
  setCamerasObject: any,
  navigate: NavigateFunction,
  productsArray: any[],
  setCheckboxesChecked: any,
  checkboxesChecked: any
) => {
  const {
    setMoreDataToLoadAutoAdd,
    setLoadingMoreAutoAddData,
    nvrNextString,
    setNvrNextString,
    setTotalCamerasPerAPIResponse,
  } = useCameraAutoAddStore.getState();

  const retryFunction = () => {
    handleLoadMoreAutoAddData(
      setCamerasList,
      setCamerasObject,
      navigate,
      productsArray,
      setCheckboxesChecked,
      checkboxesChecked
    );
  };

  const AxiosUI = createApi(``);

  AxiosUI.get(`nvr_camera/${nvrNextString}`).then(
    (response: AxiosResponse) => {
      // Update total cameras count from API response
      if (response.data.count !== undefined) {
        setTotalCamerasPerAPIResponse(response.data.count);
      }
      setCamerasList((previousState: any) => ({
        ...previousState,
        ...response.data,
        results: [...(previousState.results || []), ...response.data.results],
      }));
      if (response.data.next) {
        setMoreDataToLoadAutoAdd(true);
        setNvrNextString(
          response.data.next.slice(response.data.next.indexOf("?"))
        );
      } else {
        setMoreDataToLoadAutoAdd(false);
      }
      const nvrResults = response.data.results;
      AxiosUI.get(
        `nvr_camera/product/?customer__id=${localStorage.siteId}`
      ).then((response: AxiosResponse) => {
        const productResponse = response.data;
        const idsArray: any = [];
        productResponse.forEach((array: any[]) => {
          idsArray.push(array[1]);
        });

        // Batch all checkbox state updates into a single update to prevent multiple re-renders
        const newCheckboxesState: any = { ...checkboxesChecked };

        // Update camerasObject: merge new cameras and add product IDs if header checkboxes are checked
        setCamerasObject((previousCamerasObject: any) => {
          // First, merge the new cameras into the object
          const newCamerasObject = createCamerasObject(nvrResults);
          const updatedCamerasObject = {
            ...(previousCamerasObject || {}),
            ...newCamerasObject,
          };

          idsArray.forEach((id: any) => {
            if (productsMatcher("Name", id, productResponse)) {
              const name = productsMatcher("Name", id, productResponse);
              const productId = productsMatcher("Id", name, productsArray);

              // Preserve the existing header checkbox state (don't overwrite it)
              // Only initialize if it doesn't exist
              if (newCheckboxesState[name] === undefined) {
                newCheckboxesState[name] = false;
              }
              // Check if the header checkbox is checked for this product
              const isProductHeaderChecked = checkboxesChecked[name] === true;

              nvrResults.forEach((object: any) => {
                if (!object.camera) {
                  const newName = `${name}${object.id}`;
                  // Initialize new row checkboxes based on header checkbox state
                  newCheckboxesState[newName] = isProductHeaderChecked;

                  // If header checkbox is checked, add product ID to the camera's products array
                  if (
                    isProductHeaderChecked &&
                    updatedCamerasObject[object.id]
                  ) {
                    const cameraProducts = updatedCamerasObject[object.id].products;
                    const blockedProductIds = getBlockedProductIdsForSelectedIds(
                      cameraProducts,
                      productsArray as [string, number][]
                    );
                    if (
                      !blockedProductIds.has(productId) &&
                      !cameraProducts.includes(productId)
                    ) {
                      updatedCamerasObject[object.id] = {
                        ...updatedCamerasObject[object.id],
                        products: [...cameraProducts, productId],
                      };
                    } else if (blockedProductIds.has(productId)) {
                      newCheckboxesState[newName] = false;
                    }
                  }
                }
              });
            }
          });

          return updatedCamerasObject;
        });

        // Single state update instead of multiple individual updates
        setCheckboxesChecked(newCheckboxesState);
      });

      setLoadingMoreAutoAddData(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setLoadingMoreAutoAddData(false);
      });
    }
  );
};
